"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var react_virtualized_auto_sizer_1 = require("react-virtualized-auto-sizer");
var memoize = require("fast-memoize");
var sok_ui_1 = require("@caddigital/sok-ui");
var ParticipantsActions = require("@caddigital/sok-reducers/lib/actions/bid/participants");
var GenericErrorMessage_1 = require("components/GenericErrorMessage");
var translate_1 = require("utils/translate");
var Types = require("types");
var viewport_1 = require("reducers/viewport");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var text_1 = require("utils/text");
var search_1 = require("utils/search");
var avatars_1 = require("components/Avatar/avatars");
var Header_1 = require("./Header");
var ListRow_1 = require("./ListRow");
var filters_1 = require("./filters");
var moment = require("moment");
var ReliablePartnerStatus_1 = require("components/ReliablePartnerStatus");
var SortButton = sok_ui_1.Table.SortButton;
var headers = [];
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        userGroups: state.bid.userGroups.list,
        list: state.bid.participants,
        isMobile: (0, viewport_1.isMobile)(state.viewport),
        selectedLanguage: selectedLanguage,
        user: state.auth.current.user
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetch: function (bid) { return dispatch(ParticipantsActions.fetchRequest(bid)); },
    setPaginationOptions: function (offset, limit) {
        return dispatch(ParticipantsActions.setPaginationOptions(offset, limit));
    },
    setColumnFilter: function (field, value) {
        return dispatch(ParticipantsActions.setColumnFilter(field, value));
    },
    setOrderBy: function (orderBy, order) {
        return dispatch(ParticipantsActions.setOrderBy(orderBy, order));
    },
    toggleSelect: function (isSelected, user) {
        return dispatch(ParticipantsActions.toggleSelect(isSelected, user));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var getColValueLength = function (item, column) {
    var _a;
    if (column === 'name') {
        var nameLength = (0, text_1.calculateStringLength)("".concat(item.user.firstName, " ").concat(item.user.lastName));
        var emailLength = (0, text_1.calculateStringLength)(item.user.email);
        return nameLength < emailLength ? emailLength : nameLength;
    }
    if (column === 'company') {
        return (0, text_1.calculateStringLength)((item.company || '').toString());
    }
    if (column === 'reliablePartnerReport') {
        return (0, text_1.calculateStringLength)((0, ReliablePartnerStatus_1.reliablePartnerStatusText)((_a = item.reliablePartnerStatus) === null || _a === void 0 ? void 0 : _a.value));
    }
    if (column === 'offerSubmitted' && item && item.offerSubmitted) {
        return (0, text_1.calculateStringLength)(item.offerSubmitted.toString());
    }
    return 100;
};
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, recompose_1.withState)('contentWidth', 'setContentWidth', 0), (0, recompose_1.withState)('total', 'setTotal', 0), (0, recompose_1.withState)('users', 'setUsers', []), (0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        headers = ['name', 'company'];
        if (this.props.currentBid.procerement.reliablePartnerReport) {
            headers.push('reliablePartnerReport');
        }
        headers.push('offerSubmitted');
        this.props.fetch(this.props.currentBid);
    },
    componentDidUpdate: function (prevProps) {
        var _this = this;
        var items = this.props.list.list;
        if (this.props.list.searchString !== prevProps.list.searchString ||
            this.props.list.orderByOptions !== prevProps.list.orderByOptions ||
            this.props.list.filterOptions !== prevProps.list.filterOptions ||
            this.props.list.offset !== prevProps.list.offset ||
            this.props.list.limit !== prevProps.list.limit ||
            (prevProps.list.list.length === 0 && this.props.list.list.length) ||
            this.props.list.list !== prevProps.list.list ||
            (prevProps.list.status !== 'FETCHED' &&
                this.props.list.status === 'FETCHED')) {
            var orderBy_1 = this.props.list.orderByOptions.orderBy;
            var order_1 = this.props.list.orderByOptions.order === 'asc' ? 1 : -1;
            var list = this.props.list;
            var data = (0, filters_1.getFilteredData)({
                list: this.props.list.list,
                filters: this.props.list.filterOptions,
                normalizers: {
                    name: function (item) {
                        return "".concat(item.user.firstName, " ").concat(item.user.lastName, " ").concat(item.user.email);
                    },
                    reliablePartnerReport: function (item) {
                        var _a;
                        return (0, ReliablePartnerStatus_1.reliablePartnerStatusText)((_a = item.reliablePartnerStatus) === null || _a === void 0 ? void 0 : _a.value);
                    },
                    offerSubmitted: function (item) {
                        return item.offerSubmitted
                            ? moment(item.offerSubmitted).format('L LT')
                            : '';
                    }
                },
                searchFn: function (item) {
                    return "".concat(item.user.firstName, " ").concat(item.user.lastName, " ").concat(item.user.email)
                        .toLowerCase()
                        .includes(_this.props.list.searchString.toLowerCase());
                }
            }).sort(function (a, b) {
                var _a, _b;
                switch (orderBy_1) {
                    case 'name':
                        return ("".concat(a.user.firstName, " ").concat(a.user.lastName).localeCompare("".concat(b.user.firstName, " ").concat(b.user.lastName)) * order_1);
                    case 'company':
                        return (a.company || '').localeCompare(b.company || '') * order_1;
                    case 'reliablePartnerReport':
                        var aStatus = (0, ReliablePartnerStatus_1.reliablePartnerStatusText)((_a = a.reliablePartnerStatus) === null || _a === void 0 ? void 0 : _a.value).toLowerCase();
                        var bStatus = (0, ReliablePartnerStatus_1.reliablePartnerStatusText)((_b = b.reliablePartnerStatus) === null || _b === void 0 ? void 0 : _b.value).toLowerCase();
                        return aStatus.localeCompare(bStatus) * order_1;
                    case 'offerSubmitted':
                        var aDateNum = a.offerSubmitted || 0;
                        var bDateNum = b.offerSubmitted || 0;
                        return (aDateNum - bDateNum) * order_1;
                    default:
                        return 0;
                }
            });
            items = data.slice(Math.max(0, Math.min(data.length, list.offset)), Math.min(list.offset + list.limit, data.length));
            this.props.setTotal(data.length);
            this.props.setItems(items);
        }
        if (this.props.items !== prevProps.items) {
            var contentWidth_1 = 0;
            var columns_1 = this.props.list.list.reduce(function (p, item) {
                headers.forEach(function (header) {
                    var dataKey = '__' + header.replace(/-/g, '');
                    var prevValue = p[dataKey];
                    var length = getColValueLength(item, header);
                    if (prevValue !== undefined && prevValue < length) {
                        p[dataKey] = length;
                    }
                    else if (prevValue === undefined) {
                        p[dataKey] = length;
                    }
                });
                return p;
            }, {});
            headers.forEach(function (header) {
                var dataKey = '__' + header.replace(/-/g, '');
                var text = (0, translation_1.getLocalization)("bid/participantView/column/".concat(header)).toString();
                var length = (0, text_1.calculateStringLength)(text) + 42;
                var prevValue = columns_1[dataKey];
                if (prevValue && prevValue < length) {
                    columns_1[dataKey] = length;
                }
                else if (!prevValue) {
                    columns_1[dataKey] = length;
                }
            });
            var lengths_1 = Object.keys(columns_1).reduce(function (prev, x) {
                prev[x] = columns_1[x];
                return prev;
            }, {});
            // Override styles for dynamic classes
            var style = document.getElementById('BidParticipantViewCSS');
            if (style && style.parentNode) {
                style.parentNode.removeChild(style);
            }
            style = document.createElement('style');
            style.id = 'BidParticipantViewCSS';
            document.head && document.head.appendChild(style);
            var sheet_1 = style.sheet;
            contentWidth_1 += 2 * 42;
            Object.keys(lengths_1).forEach(function (className, i) {
                var col = lengths_1[className];
                if (col === undefined)
                    return;
                var colwidth = Math.max(8, 4 + col + 26); // convert to rem
                contentWidth_1 += colwidth;
                sheet_1.insertRule(".".concat(className) +
                    ' {max-width: ' +
                    colwidth +
                    'px;\n min-width: ' +
                    colwidth +
                    'px;}', i);
            });
            this.props.setContentWidth(contentWidth_1);
        }
    }
}), recompose_1.pure);
var NotFoundPlaceHolder = function (props) { return (React.createElement("div", __assign({}, props, { key: 'no-participants', className: 'no-participants' }),
    React.createElement("img", { src: (0, avatars_1.getAvatarUrl)('Grano_SokoPro_avatar_9'), width: 200, height: 200 }),
    React.createElement("b", null, (0, translation_1.getLocalization)("bid/participantView/emptyList/title")),
    React.createElement("span", null, (0, translation_1.getLocalization)("bid/participantView/emptyList/message")))); };
var createRowData = memoize(function (style, isMobile, items, selectedLanguage, selected, toggleSelect, currentBriefcase, currentBid) { return ({
    style: style,
    isMobile: isMobile,
    items: items,
    selectedLanguage: selectedLanguage,
    selected: selected,
    toggleSelect: toggleSelect,
    currentBriefcase: currentBriefcase,
    currentBid: currentBid
}); });
exports.default = enhance(function (props) {
    var itemData = createRowData({}, props.isMobile, props.items, props.selectedLanguage, props.list.selected, props.toggleSelect, props.currentBriefcase, props.currentBid);
    return (React.createElement(React.Fragment, null,
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.list.removeStatus, statusList: ['STANDBY', 'REMOVING', 'REMOVED', 'FAILED'] },
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/removeStatus/removing')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/removeStatus/removed')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/removeStatus/failed'))),
        React.createElement(sok_ui_1.RequestStatusBox, { status: props.list.toggleStatus, statusList: ['STANDBY', 'SAVING', 'SUCCESS', 'FAILED'] },
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/toggleStatus/saving')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/disableStatus/success')),
            React.createElement("span", null, (0, translation_1.getLocalization)('bid/participants/disableStatus/failed'))),
        React.createElement("div", { className: 'bid-participants-view-list-container' },
            React.createElement("div", { className: 'sok-list-content bid-participants-view-list ' +
                    props.list.status.toLowerCase() },
                props.list.status === 'FAILED' && (React.createElement(GenericErrorMessage_1.default, { key: 'error' },
                    React.createElement(GenericErrorMessage_1.ErrorButton, { onClick: function () { return props.fetch(props.currentBid); } }))),
                (props.list.status === 'FETCHING' ||
                    props.list.status === 'STANDBY') && (React.createElement("div", { key: 'loading', className: 'loading' },
                    React.createElement(sok_ui_1.LoadingSpinner, null))),
                props.list.status === 'FETCHED' && props.items && (React.createElement(react_virtualized_auto_sizer_1.default, null, function (_a) {
                    var width = _a.width, height = _a.height;
                    return (React.createElement(sok_ui_1.List, { itemCount: props.items.length, itemData: itemData, overscanCount: 8, width: width, height: height, itemHeight: 50, itemWidth: props.contentWidth, header: React.createElement(Header_1.default, __assign({}, props, { headers: headers })), placeholder: React.createElement(NotFoundPlaceHolder, null) }, ListRow_1.default));
                })))),
        React.createElement(sok_ui_1.Pagination, { key: 'pagination', limit: props.list.limit, total: props.total, limitOptions: props.list.itemsPerPage, offset: props.list.offset, updatePageState: function (offset, limit) {
                props.setPaginationOptions(offset, limit);
                props.updateUrl(props.pathname +
                    (0, search_1.getQueryParams)(__assign(__assign({}, props.queryParams), { offset: props.queryParams &&
                            (props.queryParams.limit || '') !== limit.toString()
                            ? 0
                            : offset, limit: limit })));
            } })));
});
